// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#pwt-remove-waypoint-btn[data-v-c58c4846]{color:var(--v-secondary-base)}#pwt-remove-waypoint-btn[data-v-c58c4846]:hover{color:var(--v-error-base)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
